export const usersSelector = store => store.usersReducer.list;
export const isLoadingUsersSelector = store => store.usersReducer.isLoading;
export const errorUsersList = store => store.usersReducer.error;
